<script setup>
/**
 * FormControlTemplatesTemplatesLazyLoad
 * A checkbox that is only visible when beta mode is enabled.
 * This component wraps the standard FormControlTypeCheckbox and applies conditional visibility logic.
 */
import {useAppStore} from '@/stores/appStore'
import FormControlTypeCheckbox from '@/common/form-control-type/FormControlTypeCheckbox.vue'

const props = defineProps({
    formId: String,
    field: Object,
    currentData: Object,
})

const appStore = useAppStore()

if (!appStore.betaMode) {
    props.field.hidden = true
}
</script>

<template>
    <FormControlTypeCheckbox
        :form-id="formId"
        :field="field"
        :current-data="currentData"
    />
</template>